import React, { useState, useEffect } from 'react';
import '../styles/filtro.css';
import { getCatalogTags } from '../services/catalogApi';

const PRECIO_MIN = 0;
const PRECIO_MAX = 1000;

const Filtros = ({ onFiltrar, filtrosIniciales, onBuscar, mostrarBusqueda = true }) => {
  const [minPrecio, setMinPrecio] = useState(PRECIO_MIN);
  const [maxPrecio, setMaxPrecio] = useState(PRECIO_MAX);
  const [categoria, setCategoria] = useState('');
  const [orden, setOrden] = useState('');
  const [enOferta, setEnOferta] = useState(false);
  const [busqueda, setBusqueda] = useState('');
  const [tags, setTags] = useState([]);
  const [tagIds, setTagIds] = useState([]);
  const [mostrarTodosTags, setMostrarTodosTags] = useState(false);
  const MAX_TAGS_VISIBLES = 15;

  useEffect(() => {
    getCatalogTags()
      .then((etiquetas) => setTags(Array.isArray(etiquetas) ? etiquetas : []))
      .catch((err) => {
        console.error('Error cargando tags', err);
        setTags([]);
      });
  }, []);

  useEffect(() => {
    if (filtrosIniciales) {
      setMinPrecio(filtrosIniciales.minPrecio ?? PRECIO_MIN);
      setMaxPrecio(filtrosIniciales.maxPrecio ?? PRECIO_MAX);
      setCategoria(filtrosIniciales.categoria ?? '');
      setOrden(filtrosIniciales.orden ?? '');
      setEnOferta(filtrosIniciales.soloOferta ?? false);
      setTagIds(filtrosIniciales.tagIds ?? []);
    }
  }, [filtrosIniciales]);

  const aplicarFiltros = () => {
    onFiltrar({
      minPrecio: minPrecio > PRECIO_MIN ? minPrecio : undefined,
      maxPrecio: maxPrecio < PRECIO_MAX ? maxPrecio : undefined,
      categoria,
      orden,
      soloOferta: enOferta,
      tagIds,
    });
  };

  const handleMinChange = (e) => {
    const nuevoMin = Number(e.target.value);
    if (nuevoMin <= maxPrecio) setMinPrecio(nuevoMin);
  };

  const handleMaxChange = (e) => {
    const nuevoMax = Number(e.target.value);
    if (nuevoMax >= minPrecio) setMaxPrecio(nuevoMax);
  };

  const handleBuscarSubmit = (e) => {
    e.preventDefault();
    if (onBuscar) onBuscar(busqueda);
    setBusqueda('');
  };

  const toggleTag = (id) => {
    setTagIds((prev) => (prev.includes(id) ? prev.filter((t) => t !== id) : [...prev, id]));
  };

  const tagsVisibles = mostrarTodosTags ? tags : tags.slice(0, MAX_TAGS_VISIBLES);
  const hayMasTags = tags.length > MAX_TAGS_VISIBLES;

  return (
    <section className="filtros-panel">
      {mostrarBusqueda && (
        <form className="filtros-busqueda-mobile" onSubmit={handleBuscarSubmit} role="search" aria-label="Buscar productos en tienda">
          <input
            type="search"
            value={busqueda}
            onChange={(e) => setBusqueda(e.target.value)}
            placeholder="Buscar producto..."
            className="filtros-busqueda-input"
          />
          <button type="submit" className="filtros-busqueda-btn">Buscar</button>
        </form>
      )}

      <h3 className="filtros-titulo">Filtros</h3>
      <p className="filtros-subtitulo">Encuentra productos mas rapido</p>

      <div className="filtro-item">
        <label htmlFor="categoria" className="label">Categoria</label>
        <select
          id="categoria"
          name="categoria"
          value={categoria}
          onChange={(e) => setCategoria(e.target.value)}
        >
          <option value="">Todas</option>
          <option value="2">Automotriz</option>
          <option value="1">Residencial</option>
          <option value="3">Comercial</option>
        </select>
      </div>

      <div className="filtro-item">
        <label htmlFor="orden" className="label">Ordenar por</label>
        <select
          id="orden"
          name="orden"
          value={orden}
          onChange={(e) => setOrden(e.target.value)}
        >
          <option value="">Sin orden</option>
          <option value="nombre-asc">Nombre A-Z</option>
          <option value="nombre-desc">Nombre Z-A</option>
          <option value="precio-asc">Precio: menor a mayor</option>
          <option value="precio-desc">Precio: mayor a menor</option>
        </select>
      </div>

      <div className="filtro-item">
        <label className="label">Rango de precio</label>
        <div className="rango-precio-labels">
          <span>${minPrecio.toFixed(2)}</span>
          <span>${maxPrecio.toFixed(2)}</span>
        </div>
        <div className="rango-precio-slider">
          <input
            type="range"
            min={PRECIO_MIN}
            max={PRECIO_MAX}
            step="10"
            value={minPrecio}
            onChange={handleMinChange}
          />
          <input
            type="range"
            min={PRECIO_MIN}
            max={PRECIO_MAX}
            step="10"
            value={maxPrecio}
            onChange={handleMaxChange}
          />
        </div>
      </div>

      <div className="filtro-item oferta-row">
        <label htmlFor="oferta" className="oferta-label">Solo en oferta</label>
        <input
          id="oferta"
          type="checkbox"
          className="oferta-checkbox"
          checked={enOferta}
          onChange={(e) => setEnOferta(e.target.checked)}
        />
      </div>

      <div className="filtro-item">
        <label className="label">Buscar por tags</label>
        <div className="filtros-tags">
          {tagsVisibles.map((tag) => (
            <button
              type="button"
              key={tag.tagId}
              className={`tag-option ${tagIds.includes(tag.tagId) ? 'activo' : ''}`}
              onClick={() => toggleTag(tag.tagId)}
            >
              {tag.tagNombre}
            </button>
          ))}
          {tags.length === 0 && <span className="filtros-tag-empty">Sin tags disponibles</span>}
        </div>
        {hayMasTags && (
          <button
            type="button"
            className="tags-toggle-btn"
            onClick={() => setMostrarTodosTags((prev) => !prev)}
          >
            {mostrarTodosTags ? 'Ver menos' : 'Ver más'}
          </button>
        )}
      </div>

      <button className="filtro-aplicar" onClick={aplicarFiltros} type="button">
        Aplicar filtros
      </button>
    </section>
  );
};

export default Filtros;
